import { oneOfType, node, number, string, func, bool } from "prop-types";
import React, { Fragment } from "react";
import { Link } from "react-router-dom";
import { Button } from "../../common";
import * as style from "./styles.module.scss";
import Spinner from "../../common/Spinner";

const Status = ({ status }) => {
  const attributesForStatus = {
    1: {
      style: style.onboarding__todo,
      label: "To do",
    },
    2: {
      style: style.onboarding__pending,
      label: "Pending",
    },
    3: {
      style: style.onboarding__done,
      label: "Done",
    },
    4: {
      style: style.onboarding__tosubmit,
      label: "To Submit",
    },
    5: {
      style: style.onboarding__oldVersion,
      label: "Old V.",
    },
  };

  return (
    <div
      style={{ marginRight: "9px" }}
      className={`${style.onboarding__status} ${attributesForStatus[status].style}`}
    >
      {attributesForStatus[status].label}
    </div>
  );
};

Status.propTypes = {
  status: number,
};

const OnboardingListItem = ({
  url,
  title,
  btnText,
  subtitle,
  status,
  handleClick,
  handleCustomClick,
  disabled = false,
  loading = false,
  downloadingDisabled = false,
  customButton = false,
  supportDownload = false,
  isPecan = false,
  hideStatus = false,
  upload = false,
  retry = false,
  readingListStyleButton = false,
}) => {
  const isDone = status === 3;
  return (
    <li className={`${style.onboarding__wrapper} flex-column flex-sm-row`}>
      <div className="d-flex align-items-center justify-content-between justify-content-md-start flex-grow-1 w-100">
        {hideStatus && <div style={{ height: "28px" }}></div>}
        {status && !hideStatus && <Status status={status} />}
        <div className="d-flex flex-column">
          {customButton ? (
            <div className="styles__rldownload__title___3T4ez ">{title}</div>
          ) : (
            <h6
              style={{
                fontWeight: readingListStyleButton && "300",
                color: hideStatus && "gray",
              }}
              className="mb-0"
            >
              {title}
            </h6>
          )}
          {subtitle && (
            <p className="fontSize-13 mt-hf mb-0 text-prewrap">{subtitle}</p>
          )}
        </div>
      </div>
      {downloadingDisabled && (
        // dont show any button
        <Fragment />
      )}
      {!isDone && url && !customButton && !disabled && (
        <Link
          className={
            isPecan
              ? `${style.rldownload__button} ${style.rldownload__download} btn btn-md btn-outline`
              : `btn ml-sm-1 mt-hf mt-sm-0 btn-primary ${style.onboarding__btn}`
          }
          to={url}
        >
          {btnText} {loading && <Spinner />}
        </Link>
      )}
      {!isDone &&
        status !== 4 &&
        handleClick &&
        !retry &&
        !customButton &&
        !supportDownload &&
        !hideStatus && (
          <Button
            disabled={disabled || loading}
            classes={
              readingListStyleButton
                ? `${style.rldownload__button} ${style.rldownload__download} btn btn-md btn-outline`
                : `btn btn-primary ml-sm-1 mt-hf mt-sm-0 ${style.onboarding__btn}`
            }
            onClick={handleClick}
          >
            <Fragment>{btnText}</Fragment> {loading && <Spinner />}
          </Button>
        )}
      {isDone &&
        handleClick &&
        !customButton &&
        !downloadingDisabled &&
        !hideStatus && (
          <Button
            disabled={disabled || loading}
            classes={
              readingListStyleButton
                ? `${style.rldownload__button} ${style.rldownload__download} btn btn-md btn-outline`
                : `btn btn-primary ml-sm-1 mt-hf mt-sm-0 ${style.onboarding__btn}`
            }
            onClick={handleCustomClick || handleClick}
          >
            {upload ? "Upload" : "Download"}
          </Button>
        )}
      {customButton && (
        <Link
          to={url}
          style={{ minWidth: "106px" }}
          className={`btn btn-md btn-primary ${style.onboarding__btn}`}
        >
          {btnText}4
        </Link>
      )}
    </li>
  );
};

OnboardingListItem.propTypes = {
  title: string.isRequired,
  btnText: string.isRequired,
  url: string,
  subtitle: oneOfType([string, node]),
  status: number,
  handleClick: func,
  disabled: bool,
  loading: bool,
  downloadingDisabled: bool,
  customButton: bool,
  supportDownload: bool,
  isPecan: bool,
  isCarltonForest: bool,
  hideStatus: bool,
  upload: bool,
  retry: bool,
  readingListStyleButton: bool,
};

export default OnboardingListItem;
